const options = {
  5: "bg-blue-500/5",
  10: "bg-blue-500/10",
  25: "bg-blue-500/25",
  50: "bg-blue-500/50",
  75: "bg-blue-500/75",
  90: "bg-blue-500/90",
  100: "bg-blue-500",
};

const from = {
  5: "from-blue-500/5",
  10: "from-blue-500/10",
  25: "from-blue-500/25",
  50: "from-blue-500/50",
  75: "from-blue-500/75",
  90: "from-blue-500/90",
  100: "from-blue-500",
};

export default function getBackgroundBlue500(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
